module.exports = __webpack_public_path__ + "static/media/icon-global-arrow-down.6e1e50ed.svg";